import { useId } from 'react';

/** בורר כמות עם כפתורי + / − גדולים — נוח באגודל, ושדה מספר להקלדה ישירה. */
export function NumberStepper({
  label,
  value,
  onChange,
  min = 0,
  max = 500,
  error,
}: {
  label: string;
  value: number | '';
  onChange: (v: number | '') => void;
  min?: number;
  max?: number;
  error?: string | null;
}) {
  const id = useId();
  const n = value === '' ? null : value;
  const step = (d: number) => onChange(Math.min(max, Math.max(min, (n ?? min) + d)));
  const btn =
    'flex size-12 shrink-0 items-center justify-center rounded-control border border-line-strong bg-surface text-[24px] font-bold text-ink active:bg-sunken disabled:opacity-40';
  return (
    <div>
      <label htmlFor={id} className="mb-1.5 block text-[14px] font-medium text-ink-2">
        {label}
      </label>
      <div className="flex items-center gap-2">
        <button type="button" className={btn} onClick={() => step(1)} disabled={n !== null && n >= max} aria-label="הוספה">
          +
        </button>
        <input
          id={id}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={value}
          onChange={(e) => {
            const digits = e.target.value.replace(/\D/g, '').slice(0, 3);
            onChange(digits === '' ? '' : Math.min(max, Number(digits)));
          }}
          aria-invalid={error ? true : undefined}
          className={[
            'tabular block min-h-12 w-full min-w-0 rounded-control border bg-surface text-center text-[22px] font-bold',
            'focus:border-brand focus:outline-none focus:ring-3 focus:ring-brand/20',
            error ? 'border-danger' : 'border-line-strong',
          ].join(' ')}
        />
        <button type="button" className={btn} onClick={() => step(-1)} disabled={n === null || n <= min} aria-label="הפחתה">
          −
        </button>
      </div>
      {error && <p className="mt-1.5 text-[13px] text-danger">{error}</p>}
    </div>
  );
}
